import { i18n } from '@fs/zion-locale'

export default {
  nextItemText: () => i18n.t('StatusAlreadySetView.nextItem', 'Next Item'),
  editingUnavailable: () => i18n.t('ItemInProgressByAnotherUser.editingUnavailable', 'Editing Unavailable'),
  anotherUserSubtitle: () => i18n.t('ItemInProgressByAnotherUser.subtitle', 'Another user is correcting this item.'),
  taskNotAvailable: () => i18n.t('metadatafooter.skipAndIsCorrectMessage', 'Task Not Available'),
  skipAndIsCorrectBody: (count) =>
    i18n.t(
      'metadatafooter.skipAndIsCorrectBody',
      'You only reserved the Correct Metadata task for Item {initialItemNumber}.',
      { count }
    ),
  skipMessageHeader: (itemNumber) =>
    i18n.t('metadatafooter.skipMessageHeader', 'Skip Item {itemNumber}', { itemNumber }),
  skipMessageBody: () =>
    i18n.t(
      'metadatafooter.skipMessageBody',
      'The Correct Metadata task will be need to be completed later by you or another user. Other items can still be submitted.'
    ),
  errorMarkingItemMessage: () => i18n.t('ImageOrganizeFooter.errorMarkingItem', 'Error marking metadata as correct'),
  itemSkipped: () => i18n.t('StatusAlreadySetView.skippedTitle', 'Item skipped'),
  completedTitle: () => i18n.t('StatusAlreadySetView.completedTitle', 'Metadata marked as correct'),
  resetStatusText: () => i18n.t('StatusAlreadySetView.resetStatus', 'Reset status'),
  toMakeChanges: () => i18n.t('StatusAlreadySetView.subtitle', 'to make changes'),
}
